import { CARE_SERVICE_ORGANS_PARENT_KEY, CARE_SERVICE_ORGANS_SUB_KEY } from '@/api';
import { REPORT_LINK_KEY, ReportLinkKey } from '@/shared/model';

export const NECK_SUB_ORGAN = [
  CARE_SERVICE_ORGANS_SUB_KEY.NASAL_PHARYNX,
  CARE_SERVICE_ORGANS_SUB_KEY.ORAL_PHARYNX,
  CARE_SERVICE_ORGANS_SUB_KEY.HYPOPHARYNX,
  CARE_SERVICE_ORGANS_SUB_KEY.THYROID,
  CARE_SERVICE_ORGANS_SUB_KEY.CERVICAL_LYMPH_NODE_CHAIN,
];

export const HEADER_LINKS: ReportLinkKey[] = [
  REPORT_LINK_KEY.REASON_FOR_SCAN,
  REPORT_LINK_KEY.QUALITY_REVIEW,
  REPORT_LINK_KEY.AI_FINDINGS,
];

export const FOOTER_LINKS: ReportLinkKey[] = [
  REPORT_LINK_KEY.PREVIEW,
  REPORT_LINK_KEY.FINAL_IMPRESSIONS,
  REPORT_LINK_KEY.KEY_IMAGES,
];

export const NOT_AN_ORGAN: ReportLinkKey[] = [
  REPORT_LINK_KEY.REASON_FOR_SCAN,
  REPORT_LINK_KEY.QUALITY_REVIEW,
  REPORT_LINK_KEY.AI_FINDINGS,
  REPORT_LINK_KEY.PREVIEW,
  REPORT_LINK_KEY.KEY_IMAGES,
  REPORT_LINK_KEY.FINAL_IMPRESSIONS,
];

export const DEFAULT_EXPANDED_LINK_KEYS = [CARE_SERVICE_ORGANS_PARENT_KEY.NECK];
